import { Link } from "react-router-dom";
import { ArrowRight, PlayCircle, Layers, CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";

export default function LandingHero() {
  return (
    <section className="relative overflow-hidden px-4 pt-16 pb-24 sm:px-6 sm:pt-24 sm:pb-32 lg:px-8">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-[480px] w-[820px] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,hsl(var(--primary)/0.25),transparent)] blur-2xl" />
      <div className="pointer-events-none absolute top-40 right-0 h-72 w-72 rounded-full bg-[radial-gradient(closest-side,#10B98133,transparent)] blur-2xl" />
      <div className="pointer-events-none absolute top-10 left-0 h-72 w-72 rounded-full bg-[radial-gradient(closest-side,#0EA5E933,transparent)] blur-2xl" />

      <div className="relative mx-auto max-w-4xl text-center">
        <div
          className="mx-auto inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 px-3.5 py-1.5 text-xs font-semibold text-primary animate-in fade-in-0 slide-in-from-top-2 duration-500"
          data-testid="landing-hero-pill"
        >
          <Layers className="h-3.5 w-3.5" /> AI Driven Resume Screening
        </div>

        <h1
          className="mt-6 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl animate-in fade-in-0 slide-in-from-bottom-3 duration-700"
          data-testid="landing-hero-title"
        >
          Screen and rank resumes <span className="text-primary">10x faster</span> with hireqix
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg animate-in fade-in-0 slide-in-from-bottom-3 duration-700 delay-100">
          Upload bulk resumes, score every candidate against your own competency matrix, and rank them into clean batch leaderboards — evidence-based, consistent, and fast.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row animate-in fade-in-0 slide-in-from-bottom-3 duration-700 delay-150">
          <Button asChild size="lg" className="w-full sm:w-auto" data-testid="landing-hero-cta">
            <Link to="/signup">
              Upload Resumes Now <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
          <a
            href="/#how-it-works"
            className="flex w-full items-center justify-center gap-2 rounded-xl border border-border px-5 py-2.5 text-sm font-semibold text-foreground hover:bg-muted transition-colors duration-150 sm:w-auto"
            data-testid="landing-hero-demo-link"
          >
            <PlayCircle className="h-4 w-4" /> See How It Works
          </a>
        </div>

        <div className="relative mx-auto mt-16 max-w-3xl animate-in fade-in-0 slide-in-from-bottom-4 duration-700 delay-200">
          <div className="rounded-2xl border border-border/80 bg-card p-3 shadow-xl shadow-primary/5 sm:p-4 glossy-card glossy-sheen">
            <img
              src="/images/hero-dashboard.jpg"
              alt="hireqix candidate ranking dashboard with sample batch results"
              className="w-full rounded-xl object-cover"
              data-testid="landing-hero-preview-image"
            />
          </div>

          <div className="absolute -left-6 top-10 hidden rotate-[-4deg] rounded-xl border border-border/80 bg-card px-3.5 py-2.5 shadow-lg sm:block animate-in fade-in-0 slide-in-from-left-4 duration-700 delay-300 glossy-card">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300">
                <CheckCircle2 className="h-3.5 w-3.5" />
              </span>
              <span className="text-xs font-semibold">Exceptional Hire · 94%</span>
            </div>
          </div>
          <div className="absolute -right-6 bottom-10 hidden rotate-[3deg] rounded-xl border border-border/80 bg-card px-3.5 py-2.5 shadow-lg sm:block animate-in fade-in-0 slide-in-from-right-4 duration-700 delay-500 glossy-card">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/15 text-primary">
                <Layers className="h-3.5 w-3.5" />
              </span>
              <span className="text-xs font-semibold">Batch 2 added · scores kept</span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2 text-xs text-muted-foreground animate-in fade-in-0 duration-700 delay-300">
          <span className="rounded-full border border-border/70 px-3 py-1">PDF supported</span>
          <span className="rounded-full border border-border/70 px-3 py-1">DOCX supported</span>
          <span className="rounded-full border border-border/70 px-3 py-1">No credit card to start</span>
        </div>
      </div>
    </section>
  );
}
